import '../../../theme/Colors.es.js';
import '../../../theme/Shadows.es.js';
import { Typography } from '../../../theme/Typography.es.js';
import 'react';
import { css, jsx } from '@emotion/react';
import { labelStyles, withModifier } from '@zapier/style-encapsulation';
import { baseReset, boxSizing } from '../../../style-mixins/reset.es.js';
import { FloatingBox } from '../../display/FloatingBox/FloatingBox.es.js';

const MENU_ITEM_HEIGHT = 40;
const Styles = labelStyles("FloatingMenu", {
  list: ({ visibleItems }) => [
    Object.assign(Object.assign({}, baseReset), { maxHeight: ((visibleItems || 0) + 0.5) * MENU_ITEM_HEIGHT + 10, overflow: "auto", padding: 10 })
  ],
  menuItem: ({ isDisabled, isHighlighted }) => [
    Object.assign(Object.assign(Object.assign(Object.assign({}, boxSizing), { display: "flex", alignItems: "center", height: `var(--zds-space-32)`, padding: "0 10px" }), Typography.Body2), { color: `var(--zds-text-default)`, borderRadius: "var(--zds-radius-small)", cursor: "pointer" }),
    isDisabled && withModifier("disabled", Object.assign(Object.assign({}, Typography.Body2), { color: `var(--zds-text-weakest)` })),
    isHighlighted && withModifier("enabled-highlighted", Object.assign(Object.assign({}, Typography.Body2), { color: `var(--zds-ui-primary-strongest)`, backgroundColor: `var(--zds-ui-primary-weakest)` }))
  ],
  menuItemIcon: css(Object.assign(Object.assign({}, boxSizing), { display: "flex", alignItems: "center", justifyContent: "center", marginRight: 10 })),
  menuItemText: css(Object.assign(Object.assign({}, boxSizing), { flex: 1, overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }))
});
const FloatingMenu = (_props) => {
  const props = Object.assign({ align: "stretch", visibleItems: 4 }, _props);
  const { align, "aria-label": ariaLabel, getItemProps, getKeyForItem, getLabelForItem, getMenuProps, highlightedIndex, items, maxWidth, minWidth } = props;
  return jsx(
    FloatingBox,
    { align, maxWidth, minWidth },
    jsx("ul", Object.assign({ css: Styles.list(props) }, getMenuProps({ "aria-label": ariaLabel }), { "data-zds": true }), items.map((item, index) => jsx(
      "li",
      Object.assign({}, getItemProps({ item, disabled: item.disabled }), { css: Styles.menuItem({
        isDisabled: item.disabled,
        isHighlighted: highlightedIndex === index
      }), key: getKeyForItem ? getKeyForItem(item) : index, "data-zds": true }),
      props.renderIcon && jsx("span", { css: Styles.menuItemIcon, "data-zds": true }, props.renderIcon(item, props.getLabelForItem)),
      jsx("span", { css: Styles.menuItemText, "data-zds": true }, getLabelForItem(item))
    )))
  );
};

export { FloatingMenu };
//# sourceMappingURL=FloatingMenu.es.js.map
